import { initCategoryTree } from './category-tree.js'
import { initDropzone } from './dropzone.js'
import { createApp } from 'vue'
import MediaTreeApp from './components/MediaTreeApp.vue'

document.addEventListener("DOMContentLoaded", function (event) {
    // Edit pages warn before navigating away with unsaved changes;
    // submitting disarms the warning. The expand-all trigger sits INSIDE
    // the form only on edit pages (detail views have it outside a form).
    const editToggle = document.querySelector('form [data-fdk-toggle-all]');
    if (editToggle) {
        window.onbeforeunload = function () {
            return "Are you sure?";
        }

        editToggle.closest('form').addEventListener('submit', function () {
            window.onbeforeunload = null;
        });
    }

    initDropzone();

    initCategoryTree();

    const treeEl = document.getElementById('media-tree-app')
    if (treeEl) {
        createApp(MediaTreeApp).mount(treeEl)
    }
});
